import { defineStore } from 'pinia';
import api from '../../api';

export const useStatisticsStore = defineStore('statistics', {
  state: () => ({
    portStatistics: {},
    inboundPortStatistics: [],
    outboundPortStatistics: []
  }),

  actions: {
    queryStatistics(params) {
      return api.statistics.queryStatistics(params)
        .then(json => {
          if (json.resp.respCode === 0) {
            if (params.type === 'inbound') {
              this.setInPortStatistics(json.portStatistics);
            } else {
              this.setOutPortStatistics(json.portStatistics);
            }
            // this.setPortStatistics(json.portStatistics)
          }
        })
        .catch(error => { throw error; });
    },
    setPortStatistics(data) {
      this.portStatistics = data;
    },
    setInPortStatistics(data) {
      this.inboundPortStatistics = data.rows;
    },
    setOutPortStatistics(data) {
      this.outboundPortStatistics = data.rows;
    },
    clearStatistics(params) {
      return api.statistics.clearStatistics(params)
        .then(data => data)
        .catch(error => { throw error; });
    }
  }
});